module.exports = __webpack_public_path__ + "static/assets/87a3a62c0627e925b92d3ede2f62b04f.ttf";